module.exports = __webpack_public_path__ + "img/user-icon-big.0c1c9e73.svg";